<h1 mat-dialog-title><b>{{labelDataResponse}}</b></h1>
<div mat-dialog-content>
    <div
          [formGroup]="searchorders"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
          >
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
            >
              <mat-form-field>
                <mat-label>Company name</mat-label>
                <mat-select formControlName="SelectCostumerSO">
               

                  <mat-option
                    *ngFor="let opt of PlaceOrderCustomer3"
                    [value]="opt.key"
                  >
                    {{ opt.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
            >
              <mat-form-field>
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                  <input
                    matInput
                    
                    placeholder="status"
                  />

                  <mat-option   value="0" >
                    Data Entry Not Completed
                  </mat-option>
                  <mat-option   value="1" >
                    Pending
                  </mat-option>
                  <mat-option   value="2" >
                    Warehouse Processing Order
                  </mat-option>
                  <mat-option   value="3" >
                    Order Completed
                  </mat-option>
                  <mat-option   value="4" >
                    Order Canceled
                  </mat-option>
                  <mat-option   value="5" >
                    Warehouse Completed Order
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
              <mat-form-field appearance="fill">
                <mat-label>Start date</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickersd"
                  formControlName="startDate"
               
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickersd"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickersd></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
              <mat-form-field appearance="fill">
                <mat-label>End date</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickered"
                  formControlName="endDate"
                
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickered"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickered></mat-datepicker>
              </mat-form-field>
            </div>
           
          </div>
        </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button (click)="OnChangeSearchOrderExport()">Create</button>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>